// export const BaseUrl = "http://qapp.thesoftwarestudios.com/api/";
export const BaseUrl = "https://admin.alquran.me/api/";

export enum EndpointList {
  REGISTER = "register",
  UPDATE_PROFILE = "update-profile",
  VERIFY_OTP = "verify-otp",
  VERIFY_LOGIN_WITH_OTP = "verifyLoginWithOTP",
  LOGIN = "login",
  REQUEST_EMAIL_OTP = "request-email-otp",
  REQUEST_PASSWORD_RESET_LINK = "password/email",
  RESEND_OTP = "resend-otp",
  VERIFY_EMAIL_OTP = "verify-email-otp",
  RESET_PASSWORD = "password/reset",
  ADD_FIREBASE = "firebase",
  DELETE_FIREBASE = "/firebase/delete-by-device",
  VERIFY_LOGIN_OTP = "verifyLoginWithOTP",
  AZKARS = "azkars",
  FORGOTPASS = "password/email",
  BOOKMARK = "Bookmark",
  NOTE = "Note",
}
